import React from 'react';
import clsx from 'clsx';
import './Separator.css';

const Separator = ({ className }) => (
  <div className={clsx("MenuSeparator", className)} />
)

export default Separator;
